export class Config {
    static get(key, defaultValue = '') {
        if (typeof _app_config === 'undefined') {
            return defaultValue;
        }
        const value = _app_config[key];
        return typeof value === 'undefined' ? defaultValue : value;
    }
}
